// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1vXS3","content":"LayoutSettings_content__1Gn5g"};